import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './simple-stat.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SimpleStat = _ref => {
  var label = _ref.label,
    value = _ref.value,
    className = _ref.className;
  return ___EmotionJSX("div", {
    css: styles.simpleStat,
    className: className
  }, ___EmotionJSX("div", {
    css: styles.label
  }, label), ___EmotionJSX("div", {
    css: styles.value
  }, value));
};
SimpleStat.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string
};
SimpleStat.defaultProps = {
  label: '',
  value: '',
  className: ''
};
export default SimpleStat;